import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTarget1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTarget1"><Path d="M12 6.5V10M14 12H17.5M12 14V17.5M6.5 12C6.5 12 8.85966 12 10 12M12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTarget1;
